var e = {
	invites: {
		loading: "Validating your invitation...",
		accept: {
			title: "You're Invited!",
			body: "You've been invited to join {{workspace}} as {{email}}.",
			acceptCta: "Accept Invitation",
			decline: "Decline",
			welcomeToast: "Welcome to {{workspace}}!",
			acceptFailedToast: "Failed to accept invitation",
			workspaceFallback: "Workspace"
		},
		login: {
			title: "Welcome Back",
			body: "Sign in with {{email}} to accept your invitation."
		},
		register: {
			confirmTitle: "Create Your Account",
			otpIntro: "We'll send a 6-digit verification code to",
			sendCode: "Send Verification Code",
			sendCodeFailed: "Failed to send verification code.",
			otpTitle: "Verify Your Email",
			otpBody: "Enter the code sent to {{email}}",
			profileTitle: "Complete Your Profile",
			profileBody: "Set up your name and password to finish"
		},
		errors: {
			title: "Invitation Unavailable",
			goHome: "Go to Home",
			noToken: "No invitation token provided.",
			invalidOrRevoked: "This invitation is invalid or has been revoked.",
			alreadyUsed: "This invitation has already been used.",
			expired: "This invitation has expired. Please ask the workspace owner to send a new one.",
			noLongerValid: "This invitation is no longer valid."
		}
	},
	common: {
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		guests_one: "{{count}} Guest",
		guests_other: "{{count}} Guests",
		guestsLower_one: "{{count}} guest",
		guestsLower_other: "{{count}} guests",
		noImage: "No image",
		guestFallback: "Guest",
		listingFallback: "Listing",
		note: "Note",
		dates: "Dates",
		total: "Total",
		somethingWentWrongTryAgain: "Something went wrong. Please try again."
	},
	actions: {
		accept: "Accept",
		reject: "Reject",
		decline: "Decline",
		downloadInvoice: "Download Invoice",
		changeDates: "Change Dates",
		extendBooking: "Extend Booking",
		cancelBooking: "Cancel Booking",
		checkIn: "Check In",
		offerExtension: "Offer Extension",
		extensionPending: "Extension Pending",
		sendSpecialOffer: "Send Special Offer",
		inviteToBook: "Invite to Book",
		message: "Message",
		viewAll: "View All",
		viewDetails: "View details",
		viewListing: "View listing",
		manage: "Manage",
		showMoreReviews: "Show more reviews",
		more: "More",
		addToCalendar: "Add to calendar",
		appleCalendar: "Apple Calendar",
		googleCalendar: "Google Calendar"
	},
	calendarEvent: {
		title: {
			unit: "Stay at {{listing}}",
			experience: "{{listing}}",
			service: "{{listing}}"
		},
		hostTitle: "{{guest}} at {{listing}}",
		confirmationCode: "Confirmation code: {{code}}",
		checkIn: "Check-in: {{when}}",
		checkOut: "Check-out: {{when}}",
		startsAt: "Starts: {{when}}",
		guests_one: "{{count}} guest",
		guests_other: "{{count}} guests",
		seats_one: "{{count}} seat",
		seats_other: "{{count}} seats",
		host: "Host: {{name}}",
		guest: "Guest: {{name}}",
		address: "Address: {{address}}",
		directions: "Directions: {{url}}",
		details: "Booking details: {{url}}",
		added: "Added to your calendar",
		unavailable: "Calendar isn't available on this device"
	},
	toasts: { genericError: "Something went wrong. Please try again." },
	miniCard: { booking: "Booking" },
	tripCard: { totalPaid: "Total paid" },
	tripDetails: {
		defaultTitle: "Trip details",
		checkInLabel: "CHECK-IN",
		checkoutLabel: "CHECKOUT",
		checkInTime: "3:00 PM",
		checkoutTime: "11:00 AM"
	},
	invitationInfo: {
		title: "Booking Invitation",
		checkInLabel: "CHECK-IN",
		checkOutLabel: "CHECK-OUT"
	},
	pendingInvitationCard: { title: "Booking invitation" },
	acceptInvitation: {
		title: "Accept Invitation",
		completePayment: "Complete Payment",
		nightlyStayTotal: "Nightly Stay Total",
		noteFromHost: "Note from host",
		redirectNotice: "By proceeding, you'll be redirected to complete payment. Your dates are secured until the invitation expires.",
		proceedToPayment: "Proceed to Payment",
		prepareFailed: "Failed to prepare checkout. Please try again.",
		pricingBreakdown: "Pricing Breakdown",
		paymentDetails: "Payment Details"
	},
	invitationActions: {
		acceptAndBook: "Accept & Book",
		declineTitle: "Decline Invitation",
		declineDescription: "Are you sure you want to decline this booking invitation? The held dates will be released.",
		declinedToastTitle: "Invitation Declined",
		declinedToastBody: "The dates have been released.",
		declineFailedTitle: "Failed to Decline",
		confirmedToastTitle: "Booking Confirmed!",
		confirmedToastBody: "Your stay has been secured."
	},
	modificationAlert: {
		extensionTitle: "Extension request",
		dateChangeTitle: "Date-change request",
		payExtra: "Pay extra {{amount}}",
		refund: "Refund {{amount}}",
		guestPaysExtra: "Guest pays extra {{amount}}",
		guestRefund: "Guest refunded {{amount}}",
		noPriceDifference: "No price difference",
		current: "Current",
		new: "New",
		noteFromGuest: "Note from guest",
		unitChangeTitle: "Proposed accommodation change",
		unitChangeNoCharge: "No extra charge for you",
		unitChangeDatesUnchanged: "Your dates stay the same: {{from}} – {{to}}",
		noteFromSupport: "Note from support",
		viewListing: "View listing"
	},
	modificationActions: {
		awaitingGuestPayment: "Awaiting guest payment",
		awaitingHostApproval: "Awaiting host approval",
		approve: "Approve",
		decline: "Decline",
		payDifference: "Pay difference",
		cancelRequest: "Cancel request",
		declineDateChangeTitle: "Decline date change",
		declineDateChangeDescription: "Are you sure? The held dates will be released and the guest's original dates kept.",
		cancelDateChangeTitle: "Cancel date change",
		cancelDateChangeDescription: "Are you sure you want to cancel your modification request?",
		approvedTitle: "Date change approved",
		approvedBody: "The guest has been notified.",
		approveFailedTitle: "Approval failed",
		declinedTitle: "Date change declined",
		declinedBody: "The held dates have been released.",
		declineFailedTitle: "Failed to decline",
		cancelledTitle: "Request cancelled",
		cancelledBody: "Your modification request has been cancelled.",
		cancelFailedTitle: "Failed to cancel",
		datesUpdatedTitle: "Dates updated!",
		datesUpdatedBody: "Your reservation dates have been changed.",
		tryAgain: "Please try again.",
		unitChangeApprovedTitle: "Change approved",
		unitChangeApprovedBody: "Your reservation has been moved to the new accommodation.",
		unitChangeDeclinedTitle: "Change declined",
		unitChangeDeclinedBody: "Your reservation stays at the current accommodation.",
		declineUnitChangeTitle: "Decline this change",
		declineUnitChangeDescription: "Are you sure? Your reservation will stay at the current accommodation.",
		awaitingGuestApproval: "Awaiting guest approval"
	},
	payModification: {
		title: "Pay the difference",
		completePayment: "Complete Payment",
		confirmBody: "Confirm to pay the price difference for your new reservation dates. Your booking dates update automatically once the payment succeeds.",
		proceedToPayment: "Proceed to Payment",
		prepareFailed: "Failed to prepare checkout. Please try again.",
		newDates: "New dates",
		youPayNow: "You pay now",
		paymentDetails: "Payment Details",
		differenceLineName: "Date change difference",
		differenceLineDescription: "Difference for your new reservation dates",
		confirming: "Confirming your payment…",
		confirmFailed: "We couldn't confirm your payment. Your dates are still held — you can try again.",
		retry: "Try again"
	},
	cancel: {
		title: "Cancel booking",
		policyLabel: "{{policy}} policy",
		pendingWithdrawalNotice: "Your host hasn't confirmed yet — withdrawing now gives you a full refund.",
		guestIntro: "Cancelling this booking will release your dates. The refund depends on how far in advance you cancel:",
		hostIntro: "Cancelling this booking will release the dates back to the guest. As the host, a penalty applies per the cancellation policy:",
		refundFallback: "The exact refund will be confirmed once you cancel.",
		penaltyFallback: "The exact penalty will be confirmed once you cancel.",
		refundNotice: "You'll be refunded {{percent}}% of the stay.",
		penaltyNotice: "A {{percent}}% penalty applies to this cancellation.",
		reasonLabel: "Reason (optional)",
		reasonPlaceholder: "Let us know why you're cancelling…",
		keepBooking: "Keep booking",
		stageRefund: "{{percent}}% refund",
		stagePenalty: "{{percent}}% penalty",
		withdrawnTitle: "Request withdrawn",
		cancelledTitle: "Booking cancelled",
		withdrawnBody: "Your booking request was withdrawn and fully refunded.",
		refundToastBody: "{{percent}}% refund applies ({{stage}}).",
		penaltyToastBody: "{{percent}}% penalty applies ({{stage}}).",
		failedTitle: "Cancellation failed",
		failedBody: "Something went wrong. Please try again."
	},
	review: {
		modalTitle: "Leave a review",
		overall: "Overall",
		bodyLabel: "Your review (optional)",
		bodyPlaceholder: "Tell other guests about your stay…",
		submit: "Submit review",
		submittedTitle: "Review submitted",
		submittedBody: "Thanks for sharing your stay.",
		invalidTitle: "Could not submit review",
		failedTitle: "Failed to submit review",
		failedBody: "Something went wrong. Please try again.",
		leaveReview: "Leave a review",
		threadTitle: "Review details",
		you: "You",
		host: "Host",
		noReplies: "No replies yet.",
		replyPlaceholder: "Write a reply…",
		replyAriaLabel: "Write a reply",
		replyRequired: "Reply cannot be empty",
		send: "Send",
		respondToReview: "Respond to Review →",
		wizard: {
			title: "Review your stay",
			stepOf: "Step {{current}} of {{total}}",
			question: {
				cleanliness: "How clean was the place?",
				accuracy: "How accurate was the listing?",
				check_in: "How was check-in?",
				communication: "How was communication with your host?",
				location: "How was the location?",
				value: "How was the value for what you paid?",
				host: "How was your host?"
			},
			tagsPositive: "What stood out?",
			tagsNegative: "What could have been better?",
			tagsHint: "Optional — pick any that apply.",
			publicTitle: "Tell future guests about your stay",
			publicBody: "Your review is public on the listing, with your first name.",
			privateTitle: "Anything to tell your host privately?",
			privateBody: "Only your host sees this. It never appears on the listing.",
			privateLabel: "Private note (optional)",
			privatePlaceholder: "Thanks, a suggestion, or anything they should fix…"
		},
		privateNoteLabel: "Private note — only you can see this",
		tagHighlightsTitle: "Guests often mention",
		tagsTitle: "What guests picked",
		tagCount: "{{label}} · {{count}}"
	},
	propertyReviews: {
		state: {
			guest_favorite: { support: "Rated 4.0 and above across {{count}} stays — the highest guest mark on Maat." },
			popular_choice: { support: "Booked and reviewed {{count}} times, holding a steady {{avg}}." },
			hidden_gem: {
				support_one: "Just one stay reviewed so far, rated {{avg}}. Get in early.",
				support_other: "Only {{count}} stays reviewed so far, averaging {{avg}}. Get in early."
			},
			building_reputation: {
				support_one: "One stay reviewed so far, rated {{avg}}. This home is still building its record.",
				support_other: "{{count}} stays reviewed so far, averaging {{avg}}. This home is still building its record."
			},
			new: {
				support: "No reviews yet. You would be the first to review this home.",
				supportWithAge: "No reviews yet — this home joined Maat in {{age}}. You would be the first to review it."
			}
		},
		reviewCount_one: "{{count}} review",
		reviewCount_other: "{{count}} reviews",
		howRatingsWork: "How ratings work",
		categoryLabel: { communication: "Communi­cation" },
		showMore: "Show more",
		openThread: "Read the full thread",
		showAll_one: "Show the only review",
		showAll_other: "Show all {{count}} reviews",
		allReviewsTitle_one: "{{count}} review",
		allReviewsTitle_other: "{{count}} reviews",
		guide: {
			guest_favorite: { rule: "Five or more reviews, averaging 4.0 or higher." },
			popular_choice: { rule: "Five or more reviews, averaging between 3.0 and 3.9." },
			hidden_gem: { rule: "One to four reviews so far, averaging 4.0 or higher." },
			building_reputation: { rule: "One to four reviews so far, averaging between 3.0 and 3.9." },
			new: { rule: "No reviews yet." },
			none: {
				label: "No label",
				rule: "Below 3.0, a home gets no label at all — just its rating and every review behind it."
			},
			note: "Ratings come only from guests who completed a stay, one review per booking, and cover seven parts of it: cleanliness, accuracy, check-in, communication, location, value and the host."
		},
		topicsLabel: "What guests talked about",
		showAllForTopic_one: "Show the only {{topic}} review",
		showAllForTopic_other: "Show all {{count}} {{topic}} reviews",
		allReviewsTitleForTopic_one: "{{count}} review mentioning {{topic}}",
		allReviewsTitleForTopic_other: "{{count}} reviews mentioning {{topic}}"
	},
	recentReviews: {
		title: "Recent Reviews",
		noReviews: "No reviews yet",
		emptyListing: {
			title: "No reviews for this listing yet",
			body: "Guest reviews appear once a stay at this listing is complete."
		}
	},
	hostReviews: { noReviews: "No reviews yet" },
	hostDetails: { defaultTitle: "Host details" },
	listingOverview: {
		title: "Listing overview",
		reservedProperty: "RESERVED PROPERTY"
	},
	guestActions: {
		title: "Actions",
		moreTitle: "More actions",
		unitChangePending: "Unit change — awaiting your approval"
	},
	reassignRoom: {
		action: "Reassign room",
		whyStatus: "Only pending or confirmed bookings can be moved to another room.",
		whyStarted: "Check-in is today or has passed, so the room can no longer be changed.",
		title: "Reassign room",
		current: "Currently in {{room}}",
		unnamedRoom: "Unnamed room",
		occupied: "Occupied",
		noOtherRooms: "There is no other active room of this type to move the booking to.",
		confirm: "Move to {{room}}",
		confirmIdle: "Choose a room",
		movedTitle: "Room changed",
		movedBody: "The booking is now in {{room}}.",
		failed: "Couldn't move the booking. Please try again."
	},
	hostActions: {
		title: "Actions",
		confirmedTitle: "Booking Confirmed",
		confirmedBody: "The booking has been accepted successfully.",
		confirmFailedTitle: "Confirmation Failed",
		confirmFailedBody: "Something went wrong. Please try again.",
		rejectedTitle: "Booking Rejected",
		rejectedBody: "The booking has been declined.",
		rejectFailedTitle: "Rejection Failed",
		rejectFailedBody: "Something went wrong. Please try again."
	},
	bookingRequests: {
		title: "Booking Requests",
		empty: "No pending booking requests",
		emptyListing: {
			title: "No requests for this listing",
			body: "New requests for this listing land here for your review."
		}
	},
	unifiedCalendar: { title: "Availability Calendar" },
	paymentBreakdown: {
		defaultTitle: "Payment summary",
		nightlyRate_one: "{{rate}} x {{count}} night",
		nightlyRate_other: "{{rate}} x {{count}} nights",
		coupon: "Coupon {{code}}",
		cleaningFee: "Cleaning fee",
		additionalFees: "Additional fees",
		serviceFee: "Service fee",
		platformFee: "Platform fee ({{percent}}%)",
		processingFee: "Processing fee",
		cancellationInsurance: "Cancellation insurance",
		youWillEarn: "You will earn",
		totalPaid: "Total paid"
	},
	nightlyBreakdown: {
		title: "Nightly breakdown",
		summary_one: "{{count}} night · {{total}}",
		summary_other: "{{count}} nights · {{total}}",
		exchangeRate: "Exchange rate",
		rateCaptured: "Rate captured {{date}}",
		cleaningFee: "Cleaning fee",
		additionalFees: "Additional fees",
		serviceFee: "Service fee",
		total: "Total"
	},
	coupons: {
		redemptionsOverTime: "Redemptions over time",
		statusBreakdown: "Status breakdown",
		redemptions: "Redemptions",
		noRedemptions: "No redemptions yet.",
		guest: "Guest",
		listing: "Listing",
		booking: "Booking",
		discount: "Discount",
		status: "Status",
		when: "When",
		viewBooking: "View booking",
		appliesTo: "Applies to",
		totalDiscountGiven: "Total discount given",
		avgDiscount: "Avg discount / redemption",
		ends: "Ends",
		budgetUtilization: "Budget utilization",
		spentOfAllocated: "Spent of allocated",
		redemptionStatus: {
			confirmed: "Confirmed",
			reserved: "Reserved",
			released: "Released"
		}
	},
	cancellationSummary: {
		nonRefundable: "Non-refundable",
		freeAnytime: "Free cancellation anytime before check-in",
		freeUntilDays_one: "Free cancellation until {{count}} day before check-in",
		freeUntilDays_other: "Free cancellation until {{count}} days before check-in",
		freeUntilHours_one: "Free cancellation until {{count}} hour before check-in",
		freeUntilHours_other: "Free cancellation until {{count}} hours before check-in"
	},
	availabilityCalendar: {
		previousMonth: "Previous month",
		nextMonth: "Next month",
		tryAnotherDate: "Try another date",
		stayConditions: "Stay conditions",
		pickCheckout: "Now pick your check-out date.",
		minStay: "{{count}}-night minimum stay",
		maxStay: "{{count}}-night maximum stay",
		checkoutUnavailable: "That date isn't available for check-out.",
		minStayError_one: "That's only {{count}} night — this stay needs {{minStay}}.",
		minStayError_other: "That's only {{count}} nights — this stay needs {{minStay}}.",
		maxStayError_one: "That's {{count}} night — this stay allows at most {{maxStay}}.",
		maxStayError_other: "That's {{count}} nights — this stay allows at most {{maxStay}}.",
		noCheckoutOn: "No check-outs on {{day}}",
		stayRejected: "The property's rules don't allow this stay.",
		nightClosed: "The host has closed one of these nights.",
		nightClosedOn: "The host has closed the night of {{date}}.",
		closedToArrival: "Check-in isn't available on this date.",
		closedToArrivalOn: "Check-in isn't available on {{date}}.",
		closedToDeparture: "Check-out isn't available on this date.",
		closedToDepartureOn: "Check-out isn't available on {{date}}."
	},
	checkout: {
		title: "Book your stay",
		errorTitle: "We hit a snag",
		continueToPayment: "Continue to Payment",
		backToListing: "Back to Listing",
		externalPricing: {
			recalibrating: "Pricing is updating for this listing — try again shortly.",
			unavailable: "Pricing is temporarily unavailable for this listing.",
			generic: "We couldn't price these dates just now — try again shortly."
		},
		identity: {
			notVerified: "Every booking needs a verified identity. It takes under two minutes, and once you're verified you won't be asked again.",
			pending: "We're still checking your identity documents. This usually takes a few minutes — you'll be able to book as soon as it's done.",
			rejected: "Your identity check didn't pass, so we can't take this booking yet. You can submit your documents again.",
			actions: {
				verify: "Verify my identity",
				viewStatus: "Check my verification",
				retry: "Try verifying again"
			},
			held: {
				unverified: {
					title: "Your dates are held for you",
					body: "We're keeping these dates for {{time}} while you verify your identity. It takes about two minutes, and you'll come straight back here to pay."
				},
				pending: {
					title: "We're checking your ID",
					body: "This usually takes a few minutes. Your dates stay held for {{time}}, and you can pay here as soon as you're verified."
				},
				rejected: {
					title: "We couldn't verify your ID",
					body: "Try again with a different document. Your dates are held for {{time}}."
				},
				expired: {
					title: "Your hold has ended",
					body: "These dates aren't held any more. Check they're still free and continue.",
					action: "Hold my dates again"
				},
				returnBanner: "Your dates are held for {{time}}.",
				backToCheckout: "Back to checkout"
			}
		},
		coupon: { currencyMismatch: "This code is issued in a different currency and does not apply to this booking." },
		validation: {
			minGuests: "At least 1 guest",
			maxGuests: "Up to 20 guests",
			couponTooLong: "That coupon code is too long"
		},
		errors: {
			network: "We couldn't reach the server. Check your connection and try again.",
			sessionExpired: "Your session has expired. Please sign in again to continue.",
			datesUnavailable: "These dates are no longer available for booking.",
			generic: "Something went wrong. Please try again."
		},
		trip: {
			title: "Let's confirm your trip",
			subtitle: "Pick your dates and how many guests are coming.",
			subtitleWithListing: "Pick your dates and how many guests are coming to {{listing}}.",
			datesTitle: "Your dates",
			invalidDatesTitle: "These dates don't work",
			selectDatesTitle: "Select your dates",
			selectDatesBody: "Choose a check-in and check-out date above to continue.",
			guestsLabel: "Guests",
			guestsHint: "Total number of guests staying, including yourself."
		},
		policy: {
			title: "How flexible do you want to be?",
			subtitle: "Choose the cancellation policy that fits your plans. More flexibility may add a small premium.",
			included: "Included"
		},
		review: {
			title: "Review and confirm",
			subtitle: "Double-check the details below before you pay.",
			stayTitle: "Your stay",
			policyTitle: "Cancellation policy",
			promoTitle: "Promo code",
			couponPlaceholder: "Enter a coupon code",
			couponApplied: "Coupon {{code}} applied.",
			inviteApplied: "Invite discount applied",
			removeInviteDiscount: "Remove invite discount",
			priceDetails: "Price details"
		},
		payment: {
			title: "Complete Payment",
			heldUntil: "Your dates are held until {{date}}.",
			timeLeft: "{{time}} left to complete your payment — your dates are held for you until then.",
			timeUp: "Your hold has run out. Pay now and we will confirm your dates if they are still free.",
			total: "Total: {{amount}}",
			detailsTitle: "Payment Details",
			holdTitle: "Your hold",
			totalLabel: "Total",
			secureHint: "You'll review and confirm the amount on the secure payment screen.",
			sdkUnavailable: "Payments aren't available in this build. Rebuild the dev client with the payment module (expo run:ios / run:android) and try again.",
			payNow: "Pay now"
		},
		confirmation: {
			title: "Payment Received",
			body: "Your payment has been processed successfully. We're now preparing your booking — this usually takes just a moment.",
			preparing: "Preparing your booking…",
			confirmingTitle: "Confirming your payment",
			confirmingBody: "This only takes a moment…",
			failedTitle: "Couldn't confirm payment",
			failedBody: "We couldn't confirm a charge for this booking. Your dates are still held — you can try again.",
			retry: "Try again",
			receivedTitle: "Payment received",
			receivedBody: "We're still preparing your trip. It will appear in My Trips shortly.",
			viewTrips: "View my trips",
			slotBody: "Your session is being confirmed. We'll email you as soon as it's booked, and it will appear in Trips."
		},
		inventoryKind: {
			modification: "Experiences and services can't be rescheduled or changed. Cancel this booking and book the session you want instead.",
			unitChange: "This booking isn't for a place to stay, so there's no room to move it to.",
			invitation: "Invitations aren't available for experiences and services yet.",
			guestDocuments: "Guest documents can only be shared for a stay.",
			checkout: "This listing is booked by session, not by night.",
			stayConfirmation: "There's nothing to check in or out of for an experience or a service.",
			generic: "This isn't something you can do for an experience or a service booking."
		},
		slotCancellation: {
			deadline: "Free cancellation until {{when}} ({{zone}})",
			deadlinePassed: "This session can no longer be cancelled for a refund.",
			policy: "Cancel at least 24 hours before the session starts for a full refund."
		},
		slot: {
			dateLabel: "Date",
			guestsLabel: "Guests",
			locationLabel: "Where",
			change: "Change",
			sessionTitle: "Your session",
			freeCancellationBy: "Free cancellation until {{deadline}}",
			durationMinutes: "{{count}} minutes",
			durationHours: "{{count}} hours"
		},
		room: {
			roomAndRate: "{{room}} · {{rate}}",
			assignedAtCheckIn: "Room assigned at check-in",
			change: "Change room or rate"
		}
	},
	hostReservations: {
		title: "Reservations",
		subtitle: "View and manage all bookings across your listings.",
		searchPlaceholder: "Search by guest or listing...",
		moreFilters: "More Filters",
		untitledListing: "Untitled listing",
		emptyTitle: "No bookings yet",
		emptyDescription: "Bookings will appear here once guests make reservations."
	},
	hostBookingsTable: {
		guest: "Guest",
		listing: "Listing",
		status: "Status",
		checkIn: "Check-in",
		checkOut: "Check-out",
		amount: "Amount",
		created: "Created",
		emptyMessage: "No bookings match your filters.",
		party: "Party",
		guestsCount_one: "{{count}} guest",
		guestsCount_other: "{{count}} guests",
		seatsCount_one: "{{count}} seat",
		seatsCount_other: "{{count}} seats"
	},
	hostBookingsFilter: {
		allStatuses: "All statuses",
		allListings: "All listings",
		searchListings: "Search listings...",
		checkInDate: "Check-in date",
		checkOutDate: "Check-out date",
		createdDate: "Created date"
	},
	guestDocuments: {
		title: "Guest ID documents",
		description: "Share ID photos for the people travelling with you. Your host sees a watermarked copy, and only until the date you choose.",
		empty: "You haven't shared any ID documents for this booking.",
		add: "Share an ID",
		addAnother: "Share another",
		notYet: "You can share ID documents once this booking is confirmed.",
		limitReached_one: "You've shared the maximum of {{count}} document for this booking.",
		limitReached_other: "You've shared the maximum of {{count}} documents for this booking.",
		share: {
			title: "Share a guest ID",
			description: "For someone travelling with you — not for yourself. We already hold your own ID from identity verification.",
			photoLabel: "ID photo",
			photoHint: "A clear photo or scan of their passport or ID card.",
			choosePhoto: "Choose a photo",
			replacePhoto: "Choose a different photo",
			takePhoto: "Take a photo",
			chooseFromLibrary: "Choose from library",
			cameraDenied: "We need camera access to take the photo. You can turn it on in Settings.",
			libraryDenied: "We need access to your photos to pick one. You can turn it on in Settings.",
			photoRequired: "Add a photo of their ID",
			photoTooLarge: "That photo is over {{size}}. Try a smaller one.",
			photoTooSmall: "That file is too small to be a photo of an ID.",
			photoUnmeasured: "We couldn't read that photo's size. Try taking it again, or pick a different one.",
			photoWrongType: "Use a JPEG, PNG or WebP photo.",
			nameLabel: "Their full name",
			namePlaceholder: "e.g. Amina Farouk",
			emailLabel: "Their email address",
			emailPlaceholder: "name@example.com",
			emailHint: "Format: name@example.com",
			emailRequired: "Enter their email address",
			emailInvalid: "That doesn't look like an email address",
			nameRequired: "Enter the name of the person on the ID",
			retentionLabel: "How long should we keep it?",
			retentionHint: "Your host can see it for exactly this long. After that it's permanently deleted — by us and for them.",
			attestLabel: "I have this person's permission to share their ID.",
			attestRequired: "You need their permission before sharing their ID.",
			submit: "Share with host",
			uploading: "Uploading… {{percent}}%",
			processing: "Adding the watermark…",
			successTitle: "ID shared",
			successBody: "{{name}}'s ID is now visible to your host until {{date}}.",
			unavailableBody: "ID sharing isn't available right now. Please try again later.",
			emailPurpose: "We keep this so the person in the photo can be told their ID is held, and given a way to delete it. Your host never sees it."
		},
		row: {
			expiresIn: "Deleted in {{time}}",
			processing: "Adding the watermark…",
			failed: "We couldn't process this photo — share it again",
			openedByHost: "Opened by your host on {{date}}",
			notOpened: "Your host hasn't opened this yet",
			view: "View",
			remove: "Delete now"
		},
		revoke: {
			title: "Delete this ID now?",
			body: "{{name}}'s ID is permanently deleted and your host loses access immediately. This can't be undone.",
			confirm: "Delete it",
			cancel: "Keep it",
			successTitle: "ID deleted",
			successBody: "{{name}}'s ID has been permanently deleted.",
			failedTitle: "Couldn't delete that ID"
		}
	},
	hostGuestDocuments: {
		title: "Guest ID documents",
		description: "IDs the guest shared for the people travelling with them.",
		empty: "This guest hasn't shared any ID documents.",
		notice: "The guest is told when you open one of these. Every copy is watermarked and view-only.",
		reveal: "Reveal",
		revealing: "Opening…",
		processing: "Still processing",
		expiresIn: "Deleted in {{time}}",
		openedOn: "First opened on {{date}}",
		failedTitle: "Couldn't open that document",
		locked: {
			title: "Guest ID documents",
			body: "You don't have permission to view guest ID documents. A workspace admin can grant it."
		}
	},
	hostBookingDetails: {
		breadcrumbReservations: "Reservations",
		breadcrumbDetails: "Booking Details",
		headerTitle: "{{guest}}'s stay at {{listing}}",
		confirmationNumber: "Conf. #{{id}}",
		fallbackGuest: "Guest",
		fallbackListingRef: "the listing",
		guestDetails: "Guest details",
		earningsBreakdown: "Earnings breakdown",
		listingFallback: "Listing",
		penaltiesTitle: "Earnings applied to penalties",
		penaltiesBody: "{{amount}} of this booking's earnings was automatically applied to your outstanding cancellation penalties. ",
		viewPenalties: "View penalties"
	},
	rules: {
		listTitle: "Booking Rules",
		listSubtitle: "Define rules that automatically validate booking requests for your listings.",
		createRule: "Create Rule",
		createFirstRule: "Create your first rule",
		emptyMessage: "No booking rules yet. Create your first rule to start automating booking validation.",
		bookingRequest: "Booking Request",
		noListings: "No listings",
		listingsCount_one: "{{count}} listing",
		listingsCount_other: "{{count}} listings",
		updatedAt: "Updated {{date}}",
		actionsTooltip: "Actions",
		editRule: "Edit Rule",
		deleteRule: "Delete Rule",
		deleteConfirm: "Delete rule \"{{title}}\"? This cannot be undone.",
		notFound: "Rule not found.",
		assignedListings: "Assigned Listings",
		assignedCount_one: "{{count}} listing",
		assignedCount_other: "{{count}} listings",
		simulate: {
			title: "Simulate rule",
			run: "Run simulation",
			newSimulation: "New simulation",
			listingStep: {
				title: "Which listing should we test against?",
				empty: "Assign this rule to a listing before simulating it."
			},
			params: {
				checkIn: "Check-in date",
				checkOut: "Check-out date",
				guests: "Guests"
			},
			result: {
				loading: "Checking this booking against your rule...",
				failed: "Simulation failed. Please try again.",
				aiUnavailable: "The written summary is unavailable, but the result above is complete."
			},
			verdict: {
				allowed: "Would be accepted",
				blocked: "Would be blocked",
				unknown: "Verdict unavailable"
			},
			violations: {
				rejected: "This rule rejects the booking outright.",
				min_stay: "The stay is shorter than the minimum this rule requires.",
				max_stay: "The stay is longer than the maximum this rule allows.",
				disallow_checkout_day: "This rule does not allow checkout on that day."
			},
			facts: {
				minStay: "Minimum stay (nights)",
				maxStay: "Maximum stay (nights)",
				noLimit: "No limit",
				disallowedCheckout: "No checkout on",
				none: "None"
			}
		},
		assignListings: "Assign Listings",
		detailsBreadcrumb: "Details",
		noAssignedTitle: "No listings assigned to this rule",
		noAssignedBody: "Click \"Assign Listings\" to link listings to this rule.",
		unassignTooltip: "Unassign listing",
		listingsAlt: "Listing",
		unitInAddress: "Unit in {{address}}",
		beds_one: "{{count}} bed",
		beds_other: "{{count}} beds",
		baths_one: "{{count}} bath",
		baths_other: "{{count}} baths",
		assignModal: {
			title: "Assign Listings",
			searchPlaceholder: "Search by title, address, city...",
			moreFilters: "More Filters",
			noResults: "No listings found. Try adjusting your search or filters.",
			selectedCount_one: "{{count}} listing selected",
			selectedCount_other: "{{count}} listings selected",
			assigning: "Assigning...",
			assignCount_one: "Assign {{count}} Listing",
			assignCount_other: "Assign {{count}} Listings",
			assignError: "We couldn't assign this rule. Nothing was changed — please try again."
		},
		editor: {
			editTitle: "Edit Booking Rule",
			newTitle: "New Booking Rule",
			guide: "Guide",
			startBuilding: "Start building",
			updateRule: "Update Rule",
			saveRule: "Save Rule",
			titleRequired: "Rule title is required",
			titlePlaceholder: "Rule title",
			titleLabel: "Title",
			descriptionPlaceholder: "Description (optional)",
			descriptionLabel: "Description"
		},
		simulateDrawer: {
			title: "Simulate Rule",
			description: "Test how this booking rule evaluates against a simulated request",
			untitled: "Untitled",
			newSimulation: "New Simulation",
			simulationFailed: "Simulation failed. Please try again."
		},
		paramsForm: {
			heading: "Booking Parameters",
			checkInLabel: "Check-in Date",
			checkOutLabel: "Check-out Date",
			guestsLabel: "Guests",
			runSimulation: "Run Simulation",
			checkInRequired: "Select a check-in date",
			checkOutRequired: "Select a check-out date",
			guestsMin: "At least one guest",
			checkOutAfterCheckIn: "Check-out must be after check-in"
		},
		triggers: {
			incomingBookingRequest: "Incoming Booking Request",
			paymentSuccessful: "Payment Successful",
			cancellationRequested: "Cancellation Requested"
		},
		actions: {
			rejectBooking: {
				label: "Reject Booking",
				description: "Automatically declines the booking request"
			},
			disallowCheckoutDay: {
				label: "Disallow Checkout Day",
				description: "Prevents guests from checking out on specific days of the week"
			},
			minStay: {
				label: "Require Minimum Stay",
				description: "Enforce a minimum number of nights for the booking"
			},
			maxStay: {
				label: "Set Maximum Stay",
				description: "Cap the number of nights allowed for the booking"
			}
		},
		quickRulesActive_one: "{{count}} quick rule is active on your listings — manage it from that listing.",
		quickRulesActive_other: "{{count}} quick rules are active on your listings — manage them from each listing.",
		trigger: "Trigger",
		updated: "Updated",
		statusActive: "Active",
		statusInactive: "Turned off",
		viewOnlyNote: "Rules are created and edited on the web dashboard.",
		andMore_one: "and {{count}} more listing",
		andMore_other: "and {{count}} more listings"
	},
	hostCalendar: { title: "Calendar" },
	inviteToBook: {
		title: "Invite to Book",
		subtitle: "Select dates and send a booking invitation to this guest.",
		selectDates: "Select dates",
		nightsSelected_one: "{{count}} night selected",
		nightsSelected_other: "{{count}} nights selected",
		expiresIn: "Invitation expires in",
		selectExpiry: "Select expiry",
		expiryHelp: "The guest must accept before the invitation expires.",
		noteLabel: "Note to guest (optional)",
		notePlaceholder: "Add a personal message...",
		sendInvitation: "Send Invitation",
		selectYourDates: "Select your dates",
		expiry: {
			"5min": "5 minute",
			"1hour": "1 hour",
			"4hours": "4 hours",
			"12hours": "12 hours",
			"24hours": "24 hours",
			"48hours": "48 hours",
			"72hours": "72 hours"
		},
		toastSuccessTitle: "Invitation Sent",
		toastSuccessBody_one: "Booking invitation sent for {{count}} night.",
		toastSuccessBody_other: "Booking invitation sent for {{count}} nights.",
		toastErrorTitle: "Failed to Send Invitation"
	},
	offerExtension: {
		title: "Offer Extension",
		subtitle: "Extend this guest's stay. They'll receive a payment request.",
		extensionDates: "Extension dates",
		extensionHint: "Starts on the current checkout date. Select a new checkout below.",
		nightsSelected_one: "+{{count}} night selected",
		nightsSelected_other: "+{{count}} nights selected",
		noteLabel: "Note to guest (optional)",
		notePlaceholder: "Add a personal message...",
		sendOffer: "Send Offer",
		checkOutRequired: "Select a new checkout date",
		toastSuccessTitle: "Extension Offer Sent",
		toastSuccessBody_one: "Booking extension offer for {{count}} night sent.",
		toastSuccessBody_other: "Booking extension offer for {{count}} nights sent.",
		toastErrorTitle: "Failed to Send Offer"
	},
	sendSpecialOffer: {
		title: "Send special offer",
		subtitle: "Send this guest a one-time discount they can use at checkout.",
		discountType: "Discount type",
		selectType: "Select type",
		percentageOption: "Percentage (%)",
		fixedOption: "Fixed amount (EGP)",
		percentageOff: "Percentage off",
		amountOff: "Amount off (EGP)",
		percentagePlaceholder: "e.g. 15",
		amountPlaceholder: "e.g. 200",
		sendOffer: "Send offer",
		toastSuccessTitle: "Offer sent",
		toastSuccessBody: "Your guest received the discount in the conversation.",
		toastErrorTitle: "Failed to send offer"
	},
	adminModifications: {
		pendingTitle: "Pending accommodation change",
		historyTitle: "Modification history",
		awaitingGuest: "Awaiting guest decision",
		expiresAt: "Expires {{date}}",
		moveTo: "Move to",
		targetListing: "Target listing",
		currentListing: "Current listing",
		note: "Note",
		viewListing: "View listing",
		refund: "Refund {{amount}}",
		deficit: "Platform absorbs {{amount}}",
		noPriceChange: "No price change",
		requested: "Requested"
	},
	listingReviews: {
		title: "Reviews",
		count_one: "{{count}} review",
		count_other: "{{count}} reviews",
		showMore: "Show more reviews"
	},
	guestDocumentNotice: {
		title: "An ID in your name was shared",
		body: "{{name}} shared a copy of your identity document with a host, for a stay in {{month}}.",
		bodyNoStay: "{{name}} shared a copy of your identity document with a host.",
		expiry: "It will be deleted automatically on {{date}}.",
		reassurance: "The host can only see a watermarked copy, and only until that date. Nobody can download or forward it.",
		destroy: "Delete it now",
		destroyFailed: "We couldn't delete it just now. Please try again.",
		confirm: {
			title: "Delete this document?",
			body: "It will be permanently deleted — the copy the host can see and the original both go, and this cannot be undone.",
			action: "Delete permanently"
		},
		destroyed: {
			title: "It's been deleted",
			body: "The document has been permanently deleted and the host can no longer see it. You don't need to do anything else."
		},
		unavailable: {
			title: "This link is no longer valid",
			body: "The document may already have been deleted, or the link may have expired.",
			hint: "If you believe an ID of yours is still being held, reply to the email you received and we'll look into it."
		},
		offline: {
			title: "We couldn't reach the server",
			body: "This looks like a connection problem rather than a problem with your link.",
			retry: "Try again"
		}
	},
	sessionDetails: {
		defaultTitle: "Session details",
		timeRange: "{{start}} – {{end}}",
		seats_one: "{{count}} seat",
		seats_other: "{{count}} seats",
		timezoneNote: "Times shown in {{zone}}."
	},
	slots: {
		choose: "Choose",
		chosen: "Chosen",
		soldOut: "Sold out",
		aboutLeft_one: "about {{count}} spot left",
		aboutLeft_other: "about {{count}} spots left",
		maxGroupSize: "This one takes up to {{count}} guests",
		sessionFull: "Only {{count}} left on this session",
		decreaseSeats: "Fewer guests",
		increaseSeats: "More guests",
		guests_one: "{{count}} guest",
		guests_other: "{{count}} guests",
		timesIn: "Times shown in {{zone}}",
		showAllDates: "Show all dates",
		showDates: "Show dates",
		selectATime: "Select a time",
		scheduleTitle: "Schedule your booking",
		noSessions: {
			title: "No sessions on the calendar yet",
			body: "This one has nothing scheduled right now. Check back, or message the host."
		},
		noSessionsOnDay: "Nothing available on this day.",
		privateGroup: {
			title: "Book for just your group",
			body: "Make it private for {{amount}} more.",
			minimum: "Just meet the host's {{amount}} minimum.",
			unavailable: "This one is shared with other guests."
		},
		minGroupLine: "Host's minimum of {{count}} guests",
		seatsLine_one: "{{count}} guest x {{price}}",
		seatsLine_other: "{{count}} guests x {{price}}",
		reserve: "Reserve",
		fromPrice: "From {{amount}}",
		unavailableNow: {
			title: "Someone just took that session",
			body_one: "Only {{count}} spot is left on it. Pick another time, or fewer guests.",
			body_other: "Only {{count}} spots are left on it. Pick another time, or fewer guests.",
			bodyNone: "It is fully booked now. Pick another time.",
			action: "Pick another time"
		},
		runRefusal: {
			SLOT_RUN_EMPTY: "Pick a session before continuing.",
			SLOT_RUN_INCOMPLETE: "That time no longer has room for the whole booking.",
			SLOT_RUN_NOT_CONTIGUOUS: "The host is not free for the whole booking at that time.",
			SLOT_RUN_CANCELLED: "That session has been cancelled.",
			SLOT_GROUP_SIZE: "That party size is outside what this one takes.",
			SLOT_NOT_FOUND: "That session is no longer available.",
			SLOT_TIMEZONE_UNKNOWN: "We couldn't work out the local time for this one.",
			SLOT_QUOTE_UNAVAILABLE: "We can't price this right now. Please try again shortly."
		}
	},
	frontDesk: { refusal: {
		checkInTooEarly: "It's too early to check this guest in. Check-in opens the day before arrival.",
		noShowTooEarly: "A guest can only be marked as a no-show from their check-in day.",
		bookingNotConfirmed: "This booking isn't confirmed, so it can't be checked in or marked as a no-show.",
		bookingNotCheckedIn: "This guest hasn't checked in, so they can't be checked out."
	} }
};
//#endregion
export { e as default };
